import InstagramIcon from "@mui/icons-material/Instagram";
import { Box, Container, Link, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import dico from "src/shared/util/src/language/dico";

const Footer = () => {
  const navigate = useNavigate();
  const myDico = dico();
  const wf = myDico.webFooter;

  const handleNavigation = (path: string) => {
    navigate(path);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const sections = {
    legal: {
      title: wf.legalSectionTitle,
      links: [
        { name: wf.linkTerms, path: "/terms" },
        { name: wf.linkPrivacy, path: "/privacy" },
        { name: wf.linkLegal, path: "/legal" },
        { name: wf.linkCookies, path: "/cookies" },
      ],
    },
  };

  const socialLinks = [
    { Icon: InstagramIcon, url: "https://instagram.com/marinlespingal" },
  ];

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "background.paper",
        borderTop: "1px solid",
        borderColor: "divider",
        py: 6,
        mt: "auto",
        color: "text.primary",
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
          <Box sx={{ flex: { xs: "1 1 100%", md: "0 1 calc(25% - 16px)" } }}>
            <Typography variant="h6" color="primary" gutterBottom>
              {myDico.appName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {wf.brandDescription}
            </Typography>
            <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
              {socialLinks.map(({ Icon, url }, index) => (
                <Link
                  key={index}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: "text.secondary",
                    "&:hover": { color: "primary.main" },
                  }}
                >
                  <Icon />
                </Link>
              ))}
            </Stack>
          </Box>

          {Object.entries(sections).map(([key, section]) => (
            <Box
              key={key}
              sx={{
                flex: {
                  xs: "1 1 calc(50% - 16px)",
                  sm: "1 1 calc(15% - 16px)",
                },
              }}
            >
              <Typography variant="h6" color="text.primary" gutterBottom>
                {section.title}
              </Typography>
              <Box component="ul" sx={{ m: 0, p: 0, listStyle: "none" }}>
                {section.links.map((link, index) => (
                  <Box component="li" key={index} sx={{ mb: 1 }}>
                    <Link
                      component="button"
                      onClick={() => handleNavigation(link.path)}
                      sx={{
                        color: "text.secondary",
                        textDecoration: "none",
                        textAlign: "left",
                        "&:hover": {
                          color: "primary.main",
                          textDecoration: "underline",
                        },
                      }}
                    >
                      {link.name}
                    </Link>
                  </Box>
                ))}
              </Box>
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            mt: 5,
            pt: 3,
            borderTop: "1px solid",
            borderColor: "divider",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            {wf.copyright(new Date().getFullYear())}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {wf.developedInFrance}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
